import { render, staticRenderFns } from "./hukou.vue?vue&type=template&id=39998f1f&scoped=true&"
import script from "./hukou.vue?vue&type=script&lang=js&"
export * from "./hukou.vue?vue&type=script&lang=js&"
import style0 from "./hukou.vue?vue&type=style&index=0&id=39998f1f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39998f1f",
  null
  
)

export default component.exports